import { useEventIds } from './useEventIds'
import config from './config';

const WebAppConfig = () => {
    const { 
        currentEventID, 
        currentEventID_en, 
        currentEventID_pt_br,
        pastEventID,
        pastEventID_en,
        pastEventID_pt_br,
        isLoading, 
        error 
    } = useEventIds();

    const dynamicConfig = {
        ...config,  // Incluimos toda la configuración base
        // Sobreescribimos los IDs con los valores dinámicos
        currentEventID,
        currentEventID_en,
        currentEventID_pt_br,
        pastEventID,
        pastEventID_en,
        pastEventID_pt_br
    }; 

    return { config: dynamicConfig, isLoading, error };
};

export default WebAppConfig;